import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import messages from 'components/MyContractInfo/MRHContractInfo/messages';
import {
  StyledCaption,
  StyledPaper,
  StyledShortBody,
} from 'components/MyContractInfo/styles';
import StatusChip from 'components/StatusChip';
import { SmallSectionHeader } from 'components/Typography';
import { get } from 'lodash';
import React, { ReactNode } from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';

interface ContractItemProps {
  label: string;
  value: string | ReactNode;
}
const ContractItem = ({ value, label }: ContractItemProps) => {
  const { formatMessage } = useIntl();

  return (
    <Grid item sm={4}>
      <Grid container direction="column">
        <Grid item>
          <StyledCaption>{formatMessage(get(messages, label))}</StyledCaption>
        </Grid>
        <Grid item>
          <Box marginBottom={2}>
            {typeof value === 'string' ? (
              <StyledShortBody>{value}</StyledShortBody>
            ) : (
              value
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface MRHContractInfoType {
  intl: IntlShape;
  numPolice: string;
  souscripteur: string;
  dateDebut: string;
  dateFin: string;
  primeMensuelle: string;
  status: string;
  statusLabel: string;
}
const MRHContractInfo = (props: MRHContractInfoType) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const parentDirection = matches ? 'row' : 'column';
  const childDirection = matches ? 'column' : 'row';
  const {
    numPolice,
    souscripteur,
    dateDebut,
    dateFin,
    primeMensuelle,
    status,
    statusLabel,
  } = props;
  return (
    <StyledPaper>
      <Box padding={2}>
        <Grid container justify="space-between" direction={parentDirection}>
          <Grid item xs={6} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem label="numPolice" value={numPolice} />
              <ContractItem
                label="status"
                value={<StatusChip status={status} label={statusLabel} />}
              />
              <ContractItem
                label="tarifAnnuel"
                value={
                  <SmallSectionHeader color="#6FAD37">
                    {primeMensuelle}
                  </SmallSectionHeader>
                }
              />
            </Grid>
          </Grid>
          <Grid item xs={6} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem label="souscripteur" value={souscripteur} />
              <ContractItem label="dateDebut" value={dateDebut} />
              <ContractItem label="dateFin" value={dateFin} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default injectIntl(MRHContractInfo);
